import actions from './actions';
import mutations from './mutations';

const state = {
  userApiKey: '',
  userPoints: 0,
  userRewards: [],
  userWinRewards: [],
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
